var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ minHeight: '230px', minWidth: '180px'})},[_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }